import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_PSF_PROMOTE_OR_SHARE_CHANNEL_AWARE_CTA = defineFcm('psf_promote_or_share_channel_aware_cta')
	.asJson(
		createShapeNormalizer({
			type: 'array',
			shape: {
				type: 'enum',
				values: ['facebook', 'whatsapp'] as const,
			},
		}),
	)
	.withDefault([])
	.toConfig({
		owner: 'squad-platypus',
		scope: 'corgi-front-end',
		context: 'psf promote-or-share share slide-up',
		description:
			'Channel-aware PSF CTA (productized): per-country list of arrival channels that get the prominent "Share on <channel>" primary CTA on the promote_or_share share slide-up, matched to the signer\'s current_medium. Empty = off for that country. Both facebook and whatsapp ship the cta_only layout (channel CTA is the sole action button, Copy link moves into the grid), the winning variant of the Top-8 relaunch (CHANGE-99290), productized in CHANGE-100764. The admin seeds every newly created row from the template below.',
		template: ['facebook', 'whatsapp'],
	});
